import config from "@sg-protect/runtime-config";
import { useContext } from "react";
import { WorkspaceContext } from "./WorkspaceContext.tsx";

const SUBSCRIPTION_PATH = "billing/subscription";
const PLANS_PATH = "billing/purchase/plans";
const ACCOUNT_PATH = "account";
const WORKSPACE_OVERVIEW_PATH = "settings";
const MEMBERS_PATH = "settings/members";

export function getLegacyHomePaths(workspaceId?: string) {
    const baseUrl = config.get().home.baseUrl;
    const homeUrl = workspaceId ? `${baseUrl}/workspace/${workspaceId}` : baseUrl;

    return {
        url: homeUrl,
        subscription: `${homeUrl}/${SUBSCRIPTION_PATH}`,
        plans: `${homeUrl}/${PLANS_PATH}`,
        account: `${homeUrl}/${ACCOUNT_PATH}`,
        workspaceOverview: `${homeUrl}/${WORKSPACE_OVERVIEW_PATH}`,
        members: `${homeUrl}/${MEMBERS_PATH}`
    };
}

export function useLegacyHomePaths() {
    const workspaceContext = useContext(WorkspaceContext);

    return getLegacyHomePaths(workspaceContext?.currentWorkspace?.id);
}
